// src/components/league-creation/steps/LeagueTypeStep.js
import React from 'react';
import { Trophy } from 'lucide-react';
import { dynastyTheme } from '../../../services/colorService';
import LeagueTypeSelector from '../league-type/LeagueTypeSelector';
import DynastyConfiguration from '../league-type/DynastyConfiguration';
import RedraftConfiguration from '../league-type/RedraftConfiguration';

const LeagueTypeStep = ({ 
  formData, 
  onInputChange, 
  error 
}) => {
  return (
    <div style={{ marginBottom: dynastyTheme.tokens.spacing['2xl'] }}>
      {/* Step Header */}
      <div className="text-center" style={{ marginBottom: dynastyTheme.tokens.spacing.xl }}>
        <div 
          className={`flex items-center justify-center mx-auto ${dynastyTheme.classes.bg.primary} ${dynastyTheme.classes.shadow.primary}`}
          style={{ 
            width: '4rem', 
            height: '4rem',
            borderRadius: dynastyTheme.tokens.radius.lg
          }}
        >
          <Trophy className={dynastyTheme.classes.text.white} style={{ width: '2rem', height: '2rem' }} />
        </div>
        <h2 className={`${dynastyTheme.components.heading.h1} ${dynastyTheme.classes.text.white}`} 
            style={{ fontSize: dynastyTheme.tokens.fontSize['2xl'], marginTop: dynastyTheme.tokens.spacing.md }}>
          League Type & Draft
        </h2>
        <p className={dynastyTheme.classes.text.neutralLight}>
          Choose your league format and configure draft settings
        </p>
      </div>

      {/* League Type Selector */}
      <div style={{ marginBottom: dynastyTheme.tokens.spacing.xl }}>
        <LeagueTypeSelector
          selectedType={formData.league_type}
          onSelectType={(type) => onInputChange('league_type', type)}
        />
      </div>

      {/* Conditional Configuration Forms */}
      {formData.league_type === 'dynasty' && (
        <DynastyConfiguration
          formData={formData}
          onInputChange={onInputChange}
          error={error}
        />
      )}

      {formData.league_type === 'redraft' && (
        <RedraftConfiguration
          formData={formData}
          onInputChange={onInputChange}
          error={error}
        />
      )}
    </div>
  );
};

export default LeagueTypeStep;